<input
  [value]="
    escapeHtml
      ? (selectedOption?.element?.nativeElement?.innerHTML || value ?? null | deserializeHtmlCharacterEntities)
      : value ?? null
  "
  (click)="selectText($event.target)"
  [readOnly]="readonly"
  (input)="updateOn === 'input' && setValue(inputElement.value)"
  (blur)="updateOn === 'blur' && setValue(inputElement.value); onTouch()"
  placeholder="{{
    placeholder || '#UI_CORE.COMPONENTS.COMBO_BOX.PLACEHOLDER' | translate
  }}"
  #inputElement
/>

<div
  *ngIf="isOpen"
  class="combo-box-panel soft-scroll vertical"
  (softClickOutside)="onOutsideClick()"
  [delayClickOutsideInit]="true"
>
  <div
    *ngFor="let option of options"
    class="combo-box-select-option pointer"
    [class.selected]="option.value === value"
    [softScrollIntoView]="value === option.value"
    (click)="onSelect(option.value)"
  >
    <span
      *ngIf="(option.element.nativeElement.innerHTML || option.value)"
      [innerHTML]="(option.element.nativeElement.innerHTML || option.value) | secureHtml">
    </span>
  </div>
</div>
<ng-content select=":not(soft-combo-box-option)"></ng-content>
<i
  *ngIf="!readonly && isOpen"
  (click)="isOpen = false"
  class="fa-regular fa-chevron-up expand-icon pointer ml-4"
></i>
<i
  *ngIf="!readonly && !isOpen"
  (click)="isOpen = true"
  class="fa-regular fa-chevron-down expand-icon pointer ml-4"
></i>

<span
  class="soft-backdrop mobile-only z-300"
  *ngIf="isOpen"
  (click)="onOutsideClick()"
></span>
